import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ViewToggle = ({ viewMode, onViewModeChange }) => {
  const { colors } = useTheme();

  return (
    <div className="flex items-center justify-end px-6 py-3 gap-4 pr-2">
      {/* Icon View */}
      <button
        onClick={() => onViewModeChange('icon')}
        className={`view-toggle-btn transition-opacity ${viewMode === 'icon' ? 'opacity-100' : 'opacity-60 hover:opacity-80'}`}
      >
        <svg width="19" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" style={{ color: colors.textPrimary }}>
          <rect x="3" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="3" width="7" height="7" rx="1" />
          <rect x="3" y="14" width="7" height="7" rx="1" />
          <rect x="14" y="14" width="7" height="7" rx="1" />
        </svg>
      </button>
      {/* List View */}
      <button
        onClick={() => onViewModeChange('list')}
        className={`view-toggle-btn transition-opacity ${viewMode === 'list' ? 'opacity-100' : 'opacity-60 hover:opacity-80'}`}
      >
        <svg width="19" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" style={{ color: colors.textPrimary }}>
          <line x1="4" y1="6" x2="4" y2="6" strokeWidth="3" strokeLinecap="round" />
          <line x1="4" y1="12" x2="4" y2="12" strokeWidth="3" strokeLinecap="round" />
          <line x1="4" y1="18" x2="4" y2="18" strokeWidth="3" strokeLinecap="round" />
          <line x1="9" y1="6" x2="20" y2="6" strokeLinecap="round" />
          <line x1="9" y1="12" x2="20" y2="12" strokeLinecap="round" />
          <line x1="9" y1="18" x2="20" y2="18" strokeLinecap="round" />
        </svg>
      </button>
      {/* Hierarchical/Tree View */}
      <button
        onClick={() => onViewModeChange('tree')}
        className={`view-toggle-btn transition-opacity ${viewMode === 'tree' ? 'opacity-100' : 'opacity-60 hover:opacity-80'}`}
      >
        <svg width="19" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" style={{ color: colors.textPrimary }}>
          <rect x="3" y="3" width="6" height="18" rx="1" />
          <rect x="12" y="3" width="6" height="18" rx="1" />
          <rect x="21" y="3" width="0" height="18" />
        </svg>
      </button>
    </div>
  );
};

export default ViewToggle;
